module.exports = __webpack_public_path__ + "img/icon.0727a76c.png";